import React from 'react'
import StyledComponents from './styles';
import _ from "lodash";

import { getBidServiceProviderName } from '../../../helpers/BidsDates'

const {
	Card,
	TitleBox,
	IconBox,
	TitleIcon,
	TitleText,
	Details
} = StyledComponents;

export default function SchedulingCard({ requestData, translations, show }) {

	if(!show) return null;
	return (
		<React.Fragment>
			<Card>
				<TitleBox>
					<IconBox>
						<TitleIcon className="far fa-calendar-day" />
					</IconBox>
					<TitleText>
						{translations.title} {requestData.Project.Categories}...
					</TitleText>
				</TitleBox>
				<Details>
				{translations.descriptionOne} {getBidServiceProviderName(requestData)} {translations.descriptionTwo}
				</Details>
			</Card>
		</React.Fragment>
	)
}
